export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 w-full max-w-[400px] lg:max-w-none">
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20displaying%20colorful%20manga%20comic%20pages%20in%20vertical%20scroll%20mode%2C%20modern%20app%20interface%20design%2C%20warm%20coral%20and%20amber%20theme%2C%20clean%20minimal%20UI%20with%20manga%20panels%2C%20soft%20cream%20background%2C%20mobile%20reading%20experience%20concept%2C%20flat%20lay%20product%20photography%20style&width=800&height=600&seq=app-mobile-visual&orientation=landscape"
                alt="羞羞歪歪漫画移动端阅读体验"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-4">移动阅读</h2>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-5">
              羞羞歪歪漫画支持手机浏览器直接访问，无需下载安装，即开即看。采用响应式布局，完美适配各类屏幕尺寸，无论iOS还是Android设备，都能享受流畅的下拉式阅读体验。躺在沙发上、通勤路上、睡前片刻——随时随地，想看就看。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <div className="flex items-center gap-2 px-4 py-2 bg-background-100 rounded-full border border-background-300">
                <i className="ri-smartphone-line text-primary-600"></i>
                <span className="text-xs font-medium text-foreground-700">手机浏览器访问</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-background-100 rounded-full border border-background-300">
                <i className="ri-tablet-line text-accent-600"></i>
                <span className="text-xs font-medium text-foreground-700">平板完美适配</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}